import { IconContext } from "react-icons";
import { createRoot } from 'react-dom/client';

import './styles/index.scss'
import './i18n';
import App from './components/App';
import { migrateLegacyStorage } from './libs/legacy';

// Data stored before the rename to Atlas Studio moves to the new keys.
migrateLegacyStorage(window.localStorage);

const root = createRoot(document.querySelector("#app"));
root.render(
  <IconContext.Provider value={{className: 'react-icons'}}>
    <App/>
  </IconContext.Provider>
);

// Hide the loader.
document.querySelector(".loading").style.display = "none";
